export default "__VITE_ASSET__DOBpqMMw__"